import Swiper, { Pagination } from 'swiper'

const appsSliderInstances = [];
const appsSliderElements = document.querySelectorAll('.apps-slider');

if (appsSliderElements.length) {
    for (let i = 0; i < appsSliderElements.length; i++) {
        appsSliderInstances[i] = {
            init: false,
            instance: null,
            element: appsSliderElements[i],
        };
    }
}

function appsSlidersInit() {
    if (767 < window.innerWidth) {
        return;
    }

    if (appsSliderInstances.length === 0) {
        return;
    }

    for (let i = 0; i < appsSliderElements.length; i++) {
        if (! appsSliderInstances[i].init) {
            appsSliderInstances[i].init = true;

            appsSliderInstances[i].instance = initializeContentSlider(appsSliderInstances[i].element, i % 2 === 0);
        }
    }
}
appsSlidersInit();
window.addEventListener('resize', appsSlidersInit);

function initializeContentSlider(slider) {
    return new Swiper(slider, {
        modules: [ Pagination ],
        slidesPerView: 1,
        spaceBetween: 20,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    });
}
